import React from 'react'
import { SimpleFooter } from '../../footer/Footer'
import { AdminHeader } from '../plans/AdminHeader'
import { ProfileSection } from "./ProfileSection";
/**
 * Creado por Equilibrio Agency 2022<br>
 * Página para mostrar contenido de sección usuarios
 * @return {HTMLElement} Elementos HTML de cada componente
 * @interface AdminHeader
 */
export const ProfilePageAdmin = () => {
  
  return (
    <>
      <AdminHeader />
      <div style={{marginTop: "100px"}}></div>
      <ProfileSection />
      <SimpleFooter></SimpleFooter>
    </>
  )
}
